import React from 'react';
import Account from './Account';

export default () => (
  <Account />
);
